import { string, func } from 'prop-types';

/**
 * The component's prop types.
 * @type {Object}
 */
export default {
    children: func.isRequired,
    locale: string
};
